module.exports = __webpack_public_path__ + "static/img/love-what-you-do.c32d561.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/love-what-you-do.png
// module id = nIak
// module chunks = 0